import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02dada62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page flex justify-center" }
const _hoisted_2 = { class: "weather-box-wrapper flex flex-col p-3" }
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = { class: "select-box" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "weather-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2 text-center weather-col one-row" }, "日付", -1))
const _hoisted_8 = ["colspan"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2 text-center weather-col one-row" }, "時刻", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2 text-center weather-col align-middle icon-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, "天気")
], -1))
const _hoisted_11 = {
  class: "flex flex-col",
  style: {"height":"30px","place-content":"center","align-items":"center"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2 text-center weather-col align-middle two-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, "気温"),
  /*#__PURE__*/_createElementVNode("div", null, "℃")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2 text-center weather-col align-middle two-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, "降水量"),
  /*#__PURE__*/_createElementVNode("div", null, "mm")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2 text-center weather-col align-middle two-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, "湿度"),
  /*#__PURE__*/_createElementVNode("div", null, "％")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2 text-center weather-col align-middle icon-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, "風向")
], -1))
const _hoisted_17 = {
  class: "flex flex-col",
  style: {"height":"30px","place-content":"center","align-items":"center"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2 text-center weather-col align-middle two-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, "風速"),
  /*#__PURE__*/_createElementVNode("div", null, "m/s")
], -1))

import { computed, reactive } from 'vue'
import { useWeatherForecastStore } from '@/stores/weatherForecastStore'
import { get, countBy } from 'lodash'
import { useGlobalStore } from '@/stores/globalStore'
import moment from 'moment'

type Forecast = {
  date: string
  time: string
  weather: string
  weatherIcon: string
  temperature: string
  rainMin60: string
  humidity: string
  windDirection: string
  windDirectionRot: string
  wind: string
}

type DisplayDatum = {
  date: { [label: string]: number }
  forecast: Forecast[]
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const weatherForecastStore = useWeatherForecastStore()

const areaList = computed(() => {
  return weatherForecastStore.areaList
})

const state = reactive<{
  area: string
}>({
  area: weatherForecastStore.areaList[0].weatherAreaId,
})

weatherForecastStore.fetch()

const chunkedDisplayData = computed(() => {
  const chunked = [] as DisplayDatum[]
  let index = 0

  const date = displayData.value.date
  const forecast = displayData.value.forecast

  Object.keys(date).forEach(key => {
    const data = {} as DisplayDatum
    const count = date[key]

    data.date = { [key]: date[key] }
    data.forecast = forecast.slice(index, index + count)

    chunked.push(data)

    index += count
  })

  return chunked
})

const displayData = computed(() => {
  const forecast = weatherForecastStore.weatherForecastList[state.area]
  if (!forecast) {
    return {
      date: {},
      forecast: [],
    }
  }

  const dateData = countBy(forecast.items, item => moment(item.time).format('M月D日'))

  const forecastData = forecast.items.map(item => {
    const weatherName = {
      100: '晴れ',
      200: '曇り',
      300: '雨',
      400: '雪',
    }

    const weatherIcon = {
      100: '/images/weather/weather_sun.png',
      200: '/images/weather/weather_cloud.png',
      300: '/images/weather/weather_rain.png',
      400: '/images/weather/weather_snow.png',
    }

    const windDirection = {
      1: '北',
      2: '北北東',
      3: '北東',
      4: '東北東',
      5: '東',
      6: '東南東',
      7: '南東',
      8: '南南東',
      9: '南',
      10: '南南西',
      11: '南西',
      12: '西南西',
      13: '西',
      14: '西北西',
      15: '北西',
      16: '北北西',
    }

    const windDirectionRotate = {
      1: 90,
      2: 90 + 22.5,
      3: 135,
      4: 135 + 22.5,
      5: 180,
      6: 180 + 22.5,
      7: 225,
      8: 225 + 22.5,
      9: -90,
      10: -67.5,
      11: -45,
      12: -22.5,
      13: 0,
      14: 22.5,
      15: 45,
      16: 67.5,
    }

    return {
      date: moment(item.time).format('M月D日'),
      time: moment(item.time).format('H時'),
      weather: get(weatherName, [item.weather], ''),
      weatherIcon: get(weatherIcon, [item.weather], ''),
      temperature: item.temperature.toFixed(1),
      rainMin60: item.rainMin60.toFixed(1),
      humidity: item.humidity.toFixed(1),
      windDirection: get(windDirection, [item.windDirection], ''),
      windDirectionRot: get(windDirectionRotate, [item.windDirection], 0),
      wind: item.wind.toFixed(1),
    }
  })

  return {
    date: dateData,
    forecast: forecastData,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).area) = $event)),
            class: "mb-1"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(areaList), (area, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: area.weatherAreaId
              }, _toDisplayString(area.name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(state).area]
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalStore).isSP ? _unref(chunkedDisplayData) : [_unref(displayData)], (data, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex weather-box"
        }, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.date, (dateCount, date) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "p-2 tect-center weather-col align-middle text-left one-row",
                    key: date,
                    colspan: dateCount
                  }, _toDisplayString(date), 9, _hoisted_8))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.forecast, (forecast, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "p-2 tect-center weather-col align-middle text-center one-row",
                    key: index
                  }, _toDisplayString(forecast.time), 1))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.forecast, (forecast, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "p-2 tect-center weather-col align-middle text-center icon-row",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("img", {
                        src: forecast.weatherIcon,
                        style: {"width":"22px"}
                      }, null, 8, _hoisted_12)
                    ]),
                    _createElementVNode("div", null, _toDisplayString(forecast.weather), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.forecast, (forecast, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "p-2 tect-center weather-col align-middle text-center two-row",
                    key: index
                  }, _toDisplayString(forecast.temperature), 1))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.forecast, (forecast, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "p-2 tect-center weather-col align-middle text-center two-row",
                    key: index
                  }, _toDisplayString(forecast.rainMin60), 1))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.forecast, (forecast, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "p-2 tect-center weather-col align-middle text-center two-row",
                    key: index
                  }, _toDisplayString(forecast.humidity), 1))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.forecast, (forecast, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "p-2 tect-center weather-col align-middle text-center icon-row",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("img", {
                        src: "/images/weather/wind_direction.png",
                        style: _normalizeStyle([{"width":"18px"}, { transform: 'rotate(' + forecast.windDirectionRot + 'deg)' }])
                      }, null, 4)
                    ]),
                    _createElementVNode("div", null, _toDisplayString(forecast.windDirection), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _hoisted_18,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.forecast, (forecast, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "p-2 tect-center weather-col align-middle text-center two-row",
                    key: index
                  }, _toDisplayString(forecast.wind), 1))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})